import { IResponseProps } from '@/entities/Response'
import { IHospitalProps } from '@/entities/Hospital'

export const Types = {
  store: 'store',
  current: 'current',
  filter: 'filter'
}

export const path = 'hospital/'

export class Store implements FluxStandardAction<IResponseProps<IHospitalProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IHospitalProps>) {}
}

export class Current implements FluxStandardAction<IHospitalProps | null> {
  type = path + Types.current
  constructor(public payload: IHospitalProps | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}
